module.exports = __webpack_public_path__ + "media/notification.a6bd4d41.wav";